import { Skeleton } from "@somethings-ui/web";
import { cn } from "@/lib/utils";

const PLACEHOLDER_ROW_COUNT = 6;

interface NoticeListSkeletonProps {
  collapsed: boolean;
}

export function NoticeListSkeleton({ collapsed }: NoticeListSkeletonProps) {
  return (
    <div aria-hidden className="flex flex-col gap-0.5">
      {Array.from({ length: PLACEHOLDER_ROW_COUNT }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "flex min-h-[64px] items-center",
            collapsed ? "justify-center p-2" : "gap-3 px-4 py-3",
          )}
        >
          <Skeleton className="size-9 shrink-0 rounded-full" />
          {collapsed ? null : (
            <div className="flex min-w-0 flex-1 flex-col gap-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-40" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
